var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6195 13.8097C26.6195 20.8844 20.8844 26.6195 13.8097 26.6195C12.4435 26.6195 11.1273 26.4056 9.89261 26.0095C4.73393 24.3544 1 19.5181 1 13.8097C1 9.63714 2.99502 5.93051 6.08323 3.59168C8.23107 1.96502 10.9077 1 13.8097 1C20.8844 1 26.6195 6.73511 26.6195 13.8097Z",
    fill: "#317289",
    stroke: "#317289",
    strokeWidth: 1.54896
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0297 11.9346C13.409 11.9346 12.9951 12.3484 12.9951 12.9692V18.763C12.9951 19.3838 13.409 19.7976 14.0297 19.7976C14.6505 19.7976 15.0643 19.3838 15.0643 18.763V12.9692C15.0643 12.4519 14.547 11.9346 14.0297 11.9346Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3055 9.03804C12.8917 9.45188 12.8917 10.0726 13.3055 10.4865C13.7193 10.9003 14.3401 10.9003 14.754 10.4865C15.1678 10.0726 15.1678 9.45188 14.754 9.03804C14.3401 8.6242 13.7193 8.6242 13.3055 9.03804Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoHover);
export default __webpack_public_path__ + "static/media/info-hover.ac43e65bc34cac4930d20e51b79049cc.svg";
export { ForwardRef as ReactComponent };